// ImportErrorModal — brief 84 band B, candidate B48.
// One error modal for the import dialogs. Four of the five census copies were
// token-identical modulo the close-setter's name, which is the parameter,
// named after the donor's free identifier (the makeToast(setActiveToast)
// pattern). The FIFTH copy — the jurisdiction import's, src/App.tsx —
// diverges by one literal (maxWidth 420 vs 400): a hunk with no parameter,
// so it STAYS THERE, reported, per move-integrity-standard 1b.
import { ModalLayout } from "./SharedUI";
import { FS } from "../lib/tokens";

export function ImportErrorModal({ error, setCaImportFile, t }: any) {
  return (
    <ModalLayout
      title={t("modal.import.error_title", {
        fallback: "Import Error",
      })}
      onClose={() => setCaImportFile(null)}
      showX={false}
      closeOnOverlay
      maxWidth={400}
      cancelLabel={t("common.close", { fallback: "Close" })}
    >
      <p style={{ fontSize: FS.s11, color: "var(--rd)" }}>{error}</p>
    </ModalLayout>
  );
}
